<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Search Employee
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Enter Employee Code / First Name / Last Name</b></p>
                    <v-text-field class="padding-bot" outlined dense rounded type="text" v-model="emp"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot">-</p>
                    <v-btn class="button" @click="fetch" rounded :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <br />
        <v-card class="box" v-if="this.info != ''">
            <v-data-table :headers="headers" dense :items="info" class="elevation-1 mytable">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Employee Details
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar><br>
                </template>
                <template v-slot:item.crs_details="{ item }">
                    <v-btn icon class="btn-css btn" @click="get_crs_off(item.list_coff)">{{item.list_coff.length}}</v-btn>
                </template>
                <template v-slot:item.leave_details="{ item }">
                    <v-btn class="btn-css btn" icon @click="get_leave(item.emp_leave)"><v-icon small color="black">mdi-information</v-icon></v-btn>
                </template>
            </v-data-table>
            <v-dialog v-model="show_leave_table" max-width="600px" v-if="show_leave_table == true">
            <v-card>
                  <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Leaves Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                    <v-row justify="center" dense>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Leave Type</th>
                                    <th class="">Total</th>
                                    <th class="">Availed</th>
                                    <th class="">Remaining</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(l,index) in emp_leave" :key="l.id">
                                    <td>{{index + 1}}</td>
                                    <td>{{l.leave_type}}</td>
                                    <td>{{l.total}}</td>
                                    <td>{{l.availed}}</td>
                                    <td>{{l.remaining}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-row>
            </v-card>
                </v-col>
               <center> <v-btn class="button" @click="show_leave_table= false">Close</v-btn></center>
            </v-card>
        </v-dialog>
         <v-dialog v-model="inst_crs_off" max-width="600px" v-if="inst_crs_off == true">
            <v-card>
                  <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Employee Course Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                 <v-data-table :headers="headers1" dense :items="list_coff" class="elevation-1 mytable">
                 </v-data-table>
            </v-card>
               </v-col>
               <center> <v-btn class="button" @click="inst_crs_off= false">Close</v-btn></center>
            </v-card>
        </v-dialog>
               
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            emp: "",
            loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            show_leave_table:false,
            inst_crs_off:false,
            color: "",
            info: [],
            headers: [
                { text: "Employee Code", value: "emp_code", sortable: "true" },
                { text: "FirstName", value: "firstname", sortable: "true" },
                { text: "MiddlenName", value: "middlename", sortable: "true" },
                { text: "LastName", value: "lastname", sortable: "true" },
                { text: "Full Name", value: "fullname", sortable: "true" },
                { text: "Employee Type", value: "employeetype", sortable: "true" },
                { text: "Designation", value: "designation", sortable: "true" },
                { text: "Mobile", value: "mobile_no", sortable: "true" },
                { text: "Email", value: "personal_email", sortable: "false" },
                { text: "Employee course Details", value: "crs_details", sortable: "false" },
                { text: "Employee Leave Details", value: "leave_details", sortable: "false" },
                { text: "Aadhaar", value: "aadhar_no", sortable: "false" },
                { text: "PAN", value: "pan_no", sortable: "false" },
                { text: "DOB", value: "date_of_birth", sortable: "false" },
                { text: "Date Of Joining", value: "dateofjoining", sortable: "false" },
                { text: "Emergency Contact Name", value: "emergency_contact_name", sortable: "false" },
                { text: "Emergency Contact No", value: "emergency_contact_number", sortable: "false" },
            ],
             headers1:[
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "divisionoffering",
                    },
                ],
            list_coff:[],
            emp_leave:[]
        }),
        methods: {
            get_crs_off(list_coff){
                this.list_coff = list_coff
                this.inst_crs_off = true
            },
            get_leave(emp_leave){
                this.emp_leave = emp_leave
                this.show_leave_table = true
            },
            fetch() {
                if (this.emp == "" || this.emp == null) {
                    this.showSnackbar("#b71c1c", "Please Enter Employee code Or Name Of Employee...");
                    return;
                }
                const data = {
                    emp: this.emp,
                };
                this.loader = true;
                axios
                    .post("/RoleManagement/searchemp", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.info.length <= 0) {
                                this.showSnackbar("#b71c1c", "No Records Found..");
                            }
                            this.info = res.data.info;
                            this.loader = false;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
.mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
</style>
